/* eslint-disable @typescript-eslint/naming-convention */
import { Component, ElementRef, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { CryptoService } from '../../../abstraction/crypto.service';
import { ITransaction, TransactionChain } from '../../../models/Transactions';
import { ChargeInfoDialogComponent } from '../../user-dash/commerce-dash/charge-info-dialog/charge-info-dialog.component';
import { WITHDRAW_TRANSACTION_STATUS } from '../../../models/FiatTransaction';
import { ORDER_STATUS } from '../../../models/Order';
import { TransactionStatus } from '../../../models/Transactions';
import {
  AlertDialogComponent,
  AlertDialogData,
} from 'src/app/modules/shared/components/dialogs/alert-dialog/alert-dialog.component';

enum ACTIVITY_CATEGORY {
  ORDER = 'order',
}

const STATUS_IMAGES_SRC = 'assets/icons/status';
const statusImages = {
  completed: 'completed',
  canceled: 'canceled',
  process: 'proccess',
  refunded: 'refunded',
};
@Component({
  selector: 'app-activity',
  templateUrl: './activity.component.html',
  styleUrls: ['./activity.component.scss'],
})
export class ActivityComponent implements OnInit {
  @ViewChild('coinSelector') coinSelector: ElementRef;
  @ViewChild('activityContainer') activityContainer: ElementRef;

  @Input() activity: any;
  coinSelectorOpened = false;
  detailsPanelOpened = false;

  coinIcon: string;
  bundleName: string;
  bundleCoins: string[];

  constructor(private cryptoService: CryptoService, private dialog: MatDialog) {}

  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (!this.coinSelector?.nativeElement.contains(event.target)) {
      this.coinSelectorOpened = false;
    }
    if (!this.activityContainer?.nativeElement.contains(event.target)) {
      this.detailsPanelOpened = false;
    }
  }

  ngOnInit(): void {
    if (this.activity) {
      this.coinIcon = this.getActivityCoinImage(this.activity);

      if (this.activity.isBundle) {
        this.bundleName = this.cryptoService.getBundleName(this.activity.coin.split('_')[0]);
      }
    }
  }

  getActivityCoinImage(activity: any) {
    if (activity?.category === ACTIVITY_CATEGORY.ORDER) {
      if (activity.destCoin === 'ARS' || activity.destCoin === 'USD') {
        if (activity.isBundle) {
          return `/assets/icons/crypto/bundles/${activity.srcCoin}.svg`;
        }
        return `/assets/icons/crypto/${activity.srcCoin.toLowerCase()}.svg`;
      } else {
        if (activity.isBundle) {
          return `/assets/icons/crypto/bundles/${activity.destCoin}.svg`;
        }
        return `/assets/icons/crypto/${activity.destCoin.toLowerCase()}.svg`;
      }
    }
  }

  downloadOrder() {
    this.cryptoService.downloadCryptoTicket(this.activity.orderId).subscribe(
      (data) => {
        window.open(data.ticketUrl);
      },
      (err) => {
        this.dialog.open<AlertDialogComponent, AlertDialogData>(AlertDialogComponent, {
          panelClass: 'modal-container',
          data: {
            title: 'Error en descargar ticket',
            content:
              'Ocurrió un error en descargar tu ticket, intentá nuevamente. Si el problema persiste, comunicate por el chat.',
          },
        });
      },
    );
  }

  downloadBundleOrder(activity, crypto: string) {
    this.cryptoService.downloadBundleTicket(activity.orderId).subscribe(
      (res) => {
        window.open(
          res.find((coin) => coin.ticker === crypto.toUpperCase() + '_' + activity.coin.slice(-3))
            .ticketUrl,
        );
      },
      () => {
        this.dialog.open<AlertDialogComponent, AlertDialogData>(AlertDialogComponent, {
          panelClass: 'modal-container',
          data: {
            title: 'Error en descargar ticket',
            content:
              'Ocurrió un error en descargar tu ticket, intentá nuevamente. Si el problema persiste, comunicate por el chat.',
          },
        });
      },
    );
  }

  goToScan(activity: ITransaction) {
    if (activity.chain === TransactionChain.BSC) {
      window.open(environment.binanceTransactionBaseUrl + activity.hash);
    } else if (activity.chain === TransactionChain.ETHEREUM) {
      window.open(environment.ethereumTransactionBaseUrl + activity.hash);
    } else if (activity.chain === TransactionChain.TERRA) {
      window.open(environment.terraTransactionBaseUrl + activity.hash.toLowerCase());
    } else if (activity.chain === TransactionChain.TERRA2) {
      window.open(environment.terra2TransactionBaseUrl + activity.hash.toLowerCase());
    } else if (activity.chain === TransactionChain.POLYGON) {
      window.open(environment.polygonTransactionBaseUrl + activity.hash.toLowerCase());
    }
  }

  toggleCoinSelector(action: string) {
    if (action === 'open') {
      this.coinSelectorOpened = true;
    } else {
      this.coinSelectorOpened = false;
    }
  }

  getBundleCoins(ticker) {
    return this.cryptoService.cryptoBundles.value
      .find((bundle) => bundle.ticker === ticker)
      .coins.map((coin) => {
        return coin.ticker.toLowerCase();
      });
  }

  showDetailsPanel(action: boolean) {
    if (this.activity.isBundle && !this.bundleCoins) {
      this.bundleCoins = this.getBundleCoins(this.activity.coin.split('_')[0]);
    }
    this.detailsPanelOpened = action;
  }

  showChargeDetails(chargeId: string) {
    this.dialog.open(ChargeInfoDialogComponent, {
      backdropClass: 'dialog-primary-backdrop',
      panelClass: 'deposit',
      maxWidth: '90vw',
      maxHeight: '90vh',
      data: {
        chargeId,
        isFromPayment: true,
      },
    });
  }

  setWithdrawImageStatus(status: number): string {
    let image = statusImages.process;

    if (status === WITHDRAW_TRANSACTION_STATUS.EXECUTED) {
      image = statusImages.completed;
    } else if (
      status === WITHDRAW_TRANSACTION_STATUS.CANCELLED ||
      status === WITHDRAW_TRANSACTION_STATUS.RETRIED
    ) {
      image = statusImages.canceled;
    }

    return `${STATUS_IMAGES_SRC}/${image}.svg`;
  }

  setOrderImageStatus(status: number): string {
    let image = statusImages.process;

    if (status === ORDER_STATUS.COMPLETED) {
      image = statusImages.completed;
    } else if (status === ORDER_STATUS.CANCELLED) {
      image = statusImages.canceled;
    }

    return `${STATUS_IMAGES_SRC}/${image}.svg`;
  }

  setTransactionImageStatus(status: number): string {
    let image = statusImages.process;

    if (status === TransactionStatus.CONFIRMED) {
      image = statusImages.completed;
    } else if (status === TransactionStatus.REFUNDED) {
      image = statusImages.refunded;
    } else if (status === TransactionStatus.CANCELLED) {
      image = statusImages.canceled;
    }

    return `${STATUS_IMAGES_SRC}/${image}.svg`;
  }
}
